// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-detail-redesign-layout {
  min-height: 100vh;
}

.admin-detail-redesign-content {
  flex: 1 1;
  min-width: 0;
  padding: 30px 36px;
  background: #f5f7fb;
  box-sizing: border-box;
}

.ad-page {
  width: 100%;
  color: #203047;
  font-family: 'Malgun Gothic', Arial, sans-serif;
}

.ad-top {
  margin-bottom: 22px;
}

.ad-back {
  border: none;
  background: transparent;
  color: #64748b;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
}

.ad-back:hover {
  color: #168ff0;
}

.ad-heading {
  margin-bottom: 24px;
}

.ad-heading h2 {
  margin: 0 0 8px;
  font-size: 25px;
  font-weight: 800;
}

.ad-heading p {
  margin: 0;
  font-size: 14px;
  color: #8190a4;
}

.ad-card {
  background: #fff;
  border: 1px solid #e4eaf1;
  border-radius: 12px;
  padding: 26px;
  box-shadow: 0 2px 12px #19355409;
}

.ad-card-title {
  padding-bottom: 18px;
  margin-bottom: 8px;
  border-bottom: 1px solid #e9edf3;
}

.ad-card-title h3 {
  margin: 0 0 6px;
  font-size: 19px;
  font-weight: 800;
}

.ad-card-title span {
  font-size: 13px;
  color: #8190a4;
}

.ad-info-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  padding-top: 16px;
}

.ad-info-item {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 0;
  min-width: 0;
}

.ad-info-item > span {
  color: #75849a;
  font-size: 14px;
  font-weight: 600;
}

.ad-info-item > strong {
  color: #203047;
  font-size: 16px;
  font-weight: 700;
  overflow-wrap: anywhere;
}

.ad-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.ad-actions button {
  border-radius: 9px;
  padding: 13px 24px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.ad-danger {
  border: 1px solid #f3c4c4;
  background: #fff;
  color: #dc2626;
}

.ad-secondary {
  border: 1px solid #dce4ee;
  background: #fff;
  color: #475569;
}

.ad-primary {
  border: 1px solid #168ff0;
  background: #168ff0;
  color: #fff;
}

@media (max-width: 1100px) {
  .ad-info-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .admin-detail-redesign-content {
    padding: 20px 16px;
  }

  .ad-card {
    padding: 20px;
  }

  .ad-info-grid {
    grid-template-columns: 1fr;
  }

  .ad-actions {
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/admin/AdminDetailRedesign.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".admin-detail-redesign-layout {\n  min-height: 100vh;\n}\n\n.admin-detail-redesign-content {\n  flex: 1;\n  min-width: 0;\n  padding: 30px 36px;\n  background: #f5f7fb;\n  box-sizing: border-box;\n}\n\n.ad-page {\n  width: 100%;\n  color: #203047;\n  font-family: 'Malgun Gothic', Arial, sans-serif;\n}\n\n.ad-top {\n  margin-bottom: 22px;\n}\n\n.ad-back {\n  border: none;\n  background: transparent;\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n}\n\n.ad-back:hover {\n  color: #168ff0;\n}\n\n.ad-heading {\n  margin-bottom: 24px;\n}\n\n.ad-heading h2 {\n  margin: 0 0 8px;\n  font-size: 25px;\n  font-weight: 800;\n}\n\n.ad-heading p {\n  margin: 0;\n  font-size: 14px;\n  color: #8190a4;\n}\n\n.ad-card {\n  background: #fff;\n  border: 1px solid #e4eaf1;\n  border-radius: 12px;\n  padding: 26px;\n  box-shadow: 0 2px 12px #19355409;\n}\n\n.ad-card-title {\n  padding-bottom: 18px;\n  margin-bottom: 8px;\n  border-bottom: 1px solid #e9edf3;\n}\n\n.ad-card-title h3 {\n  margin: 0 0 6px;\n  font-size: 19px;\n  font-weight: 800;\n}\n\n.ad-card-title span {\n  font-size: 13px;\n  color: #8190a4;\n}\n\n.ad-info-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 20px;\n  padding-top: 16px;\n}\n\n.ad-info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 8px 0;\n  min-width: 0;\n}\n\n.ad-info-item > span {\n  color: #75849a;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.ad-info-item > strong {\n  color: #203047;\n  font-size: 16px;\n  font-weight: 700;\n  overflow-wrap: anywhere;\n}\n\n.ad-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.ad-actions button {\n  border-radius: 9px;\n  padding: 13px 24px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.ad-danger {\n  border: 1px solid #f3c4c4;\n  background: #fff;\n  color: #dc2626;\n}\n\n.ad-secondary {\n  border: 1px solid #dce4ee;\n  background: #fff;\n  color: #475569;\n}\n\n.ad-primary {\n  border: 1px solid #168ff0;\n  background: #168ff0;\n  color: #fff;\n}\n\n@media (max-width: 1100px) {\n  .ad-info-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .admin-detail-redesign-content {\n    padding: 20px 16px;\n  }\n\n  .ad-card {\n    padding: 20px;\n  }\n\n  .ad-info-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .ad-actions {\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
